import { render, staticRenderFns } from "./cv-accordion-item.vue?vue&type=template&id=77676594&"
import script from "./cv-accordion-item.vue?vue&type=script&lang=js&"
export * from "./cv-accordion-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports